var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    {
      class: { "answer-report": _vm.padding, active: _vm.active },
      attrs: { disabled: _vm.active },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "v-list-item-action",
        [
          _vm.groupExamTestQuestion.isAnswered
            ? [
                _vm.isExamResultAfterQuestion && _vm.groupQuestion
                  ? _c(
                      "v-flex",
                      { attrs: { xs1: "" } },
                      [
                        _vm.exam.autoDiagnosisEnabled || _vm.isPass
                          ? _c("v-icon", { attrs: { color: "blue" } }, [
                              _vm._v("check"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isNotFullScore
                          ? _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("change_history"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isNotPass
                          ? _c("v-icon", { attrs: { color: "red" } }, [
                              _vm._v("close"),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("v-icon", { attrs: { color: "blue" } }, [
                      _vm._v("check"),
                    ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("v-list-item-action", [
        _c(
          "div",
          {
            staticClass: "font-weight-medium me-2",
            class: { gray: _vm.groupExamTestQuestion.isDescriptionQuestion },
          },
          [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        [
          _vm.groupExamTestQuestion.questionCount === 1
            ? _c(
                "v-list-item-title",
                { staticClass: "question-header-title" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.currentQuestion.headerTitle) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.groupExamTestQuestion.questionCount > 1 &&
          !_vm.groupExamTestQuestion.isDescriptionQuestion
            ? _c("SlideBar", {
                attrs: {
                  current: _vm.groupExamTestQuestion.questionAnsweredCount,
                  total: _vm.groupExamTestQuestion.questionCount,
                  align: "right",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }